(() => {
  const css = `
    button[data-testid="form-teaser"] {
      --container-background-color: rgba(244, 240, 233, 0.75) !important;
      background-color: rgba(244, 240, 233, 0.75) !important;
    }
    @media (max-width: 749px) {
      #app-embed[data-vr-sticky-teaser][class*="_appEmbedRootTeaser_"] {
        bottom: calc(var(--vr-sticky-cart-height, 0px) + 12px) !important;
      }
    }
  `;

  function connect() {
    const root = document.getElementById('app-embed-container-1163841')?.shadowRoot;
    if (!root) return false;

    function ensureStyle() {
      const existing = root.getElementById('vr-forms-teaser-style');
      const style = existing || document.createElement('style');
      style.id = 'vr-forms-teaser-style';
      if (style.textContent !== css) style.textContent = css;
      if (!existing) root.appendChild(style);
    }

    const stickyBar = document.querySelector('.sticky-add-to-cart__bar');
    const mobile = window.matchMedia('(max-width: 749px)');

    function updatePosition() {
      const embed = root.getElementById('app-embed');
      if (!embed) return;
      const active = mobile.matches &&
        embed.matches('[class*="_appEmbedRootTeaser_"]') &&
        embed.querySelector('button[data-testid="form-teaser"]') &&
        stickyBar?.dataset.stuck === 'true';
      embed.toggleAttribute('data-vr-sticky-teaser', Boolean(active));
      if (active) {
        embed.style.setProperty('--vr-sticky-cart-height', `${stickyBar.getBoundingClientRect().height}px`);
      } else {
        embed.style.removeProperty('--vr-sticky-cart-height');
      }
    }

    function syncTeaser() {
      ensureStyle();
      updatePosition();
    }

    syncTeaser();
    new MutationObserver(syncTeaser).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
    if (stickyBar) {
      new MutationObserver(updatePosition).observe(stickyBar, {
        attributes: true,
        attributeFilter: ['data-stuck'],
      });
      new ResizeObserver(updatePosition).observe(stickyBar);
    }
    mobile.addEventListener('change', updatePosition);
    return true;
  }

  if (!connect()) {
    const deadline = Date.now() + 30000;
    const timer = setInterval(() => {
      if (connect() || Date.now() >= deadline) clearInterval(timer);
    }, 250);
  }
})();

